
import {throwError as observableThrowError,  Observable ,  Subject } from 'rxjs';

import {map, catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';



import { UserPreferenceEvent } from '../../../shared/models/user-favourite-event';
import { tmsConfig } from 'src/app/core/tms-config';

@Injectable()
export class UserPreferenceService {

  public preferenceEventSubject: Subject<UserPreferenceEvent>;

  constructor(public http$: HttpClient) {
    this.preferenceEventSubject = new Subject<UserPreferenceEvent>();
  }

  // Refresh left menu
  public receiveEvent(): Observable<UserPreferenceEvent> {
    return this.preferenceEventSubject.asObservable();
  }

  // setting menuItem to be updated
  public notifyEvent(event: UserPreferenceEvent) {
    this.preferenceEventSubject.next(event);
  }

  public getRecentSearchItemsList() {
    const response$ = this.http$.get('api/core/recentItems').pipe(
      catchError((error: any) => {
        return observableThrowError(error.message);
      }));
    return response$;
  }

  public getAllSavedSearchCriterias() {
    const response$ = this.http$.get('api/data/loadsearch/ALL').pipe(
      catchError((error: any) => {
        return observableThrowError(error.message);
      }));
    return response$;
  }

  public getAllFavorites() {
    const response$ = this.http$.get('api/core/favorites').pipe(
      catchError((error: any) => {
        if (error?.error?.errors?.length) {
          if (error.error.errors[0].validationCode !== 200) {
            return observableThrowError(error.error.errors['0'].validationMessage);
          }
        }
        return observableThrowError(error?.message);
      }));
    return response$;
  }

  public deleteFavorites(prefrenceId: number) {
    const response$ = this.http$.post(`api/core/delete/` + prefrenceId, {}).pipe(
      catchError((errors: any) => {
        if (errors?.error?.errors?.length) {
          if (errors.error.errors[0].validationCode !== 200) {
            return observableThrowError(errors.error.errors['0'].validationMessage);
          }
        }
        return observableThrowError(errors?.message);
      }));
    return response$;
  }

  public fetchTablePreferences(dataTableId: string, prefType: string): Observable<Response> {
    const hdr = new HttpHeaders({ 'api': 'admin' });
    const dataUrl$ = this.http$
      .get(`api/core/user/tablepreferences/` + dataTableId + '/' + prefType , {headers: hdr}).pipe(
      map((response: any) => {
        if (response['prefType'] === 'FAVOURITECONFIG') {
          if (!response['configuration']) {
            response['configuration'] = { 'favourite': false };
            response['dataTableId'] = dataTableId;
            response['prefType'] = 'FAVOURITECONFIG';
            response['preferenceId'] = null;
          } else { response['configuration'] = JSON.parse(response['configuration']); }
        } else if (response['prefType'] === 'COLUMNCONFIG') {
          if (!response['configuration']) {
            response['dataTableId'] = dataTableId;
            response['prefType'] = 'COLUMNCONFIG';
            response['preferenceId'] = null;
            response['configuration'] = {
              hiddenPropertiesList: [],
              pinnedPropertiesList: [],
              columnWidthsObject: {},
              propertyIndexMap: {},
              pageDefinitionObject: {
                'sortColumn': null,
                'sortOrder': 0,
                'pageSize': 10
              }  // Page Definition Default Properties
            };
          } else {
            response['configuration'] = JSON.parse(response['configuration']);
          }
        } else if (response['prefType'] === 'COLUMNGROUPCONFIG') {
          if (!response['configuration']) {
            response['configuration'] = {};
            response['dataTableId'] = dataTableId;
            response['prefType'] = 'COLUMNGROUPCONFIG';
            response['preferenceId'] = null;
          } else {
            response['configuration'] = JSON.parse(response['configuration']);
          }
        }
        return response;
      }),catchError((error: any) => {
        return observableThrowError('Failed to fetch User Preferences for '
          + dataTableId + ' :: ' + error.message);
      }),);
    return dataUrl$;
  }

  public saveTablePreferences(userPreferences: any) {
    const configuration = userPreferences?.configuration || {};
    // Keep payload compatible with existing GRID_CONFIGURATION API:
    // core column prefs + optional width/page metadata for booking tables.
    const preference: any = {
      // Backend rejects null version; treat first save as version 0.
      version: userPreferences?.preferenceId ?? 0,
      preferenceData: {
        hiddenColumns: configuration.hiddenColumns || [],
        columnOrder: configuration.columnOrder || [],
        frozenColumns: configuration.frozenColumns || [],
        columnWidthsObject: configuration.columnWidthsObject || {},
        pageDefinitionObject: configuration.pageDefinitionObject || {
          sortColumn: null,
          sortOrder: 0,
          pageSize: 10,
        },
      },
    };
    const dataTableId =
      userPreferences?.dataTableId ||
      userPreferences?.configuration?.dataTableId;
    const response$ = this.http$.post(
      `${tmsConfig.tms.userPreferences}/${dataTableId}/GRID_CONFIGURATION`,
      preference
    ).pipe(
      map((response: any) => {
        return response;
      }),catchError((error: any) => {
        return observableThrowError(error);
      }),);
    return response$;
  }

  public saveSidePanelStatus(sidePanelStatus: boolean) {
    const response$ = this.http$.post(`api/core/sidepanel/update/` + sidePanelStatus, {}).pipe(
      catchError((err: any) => {
        if (err?.error?.errors?.length) {
          if (err.error.errors[0].validationCode !== 200) {
            return observableThrowError(err.error.errors['0'].validationMessage);
          }
        }
        return observableThrowError(err?.message);
      }));
    return response$;
  }

}
